import React, { type FC } from 'react';
import { xcss, Flex, Box } from '@atlaskit/primitives';
import { fg } from '@atlassian/jira-feature-gating';
import { useIntl } from '@atlassian/jira-intl';
import { GeneratingAnimation } from './generating-animation/index.tsx';
import messages from './messages.tsx';

type Props = {
	message?: string;
	hasPadding?: boolean;
};

export const StreamingStatusBar: FC<Props> = ({ message, hasPadding = true }) => {
	const { formatMessage } = useIntl();

	return (
		<Flex xcss={[baseContainerStyle, hasPadding ? withPaddingStyle : noPaddingStyle]}>
			<GeneratingAnimation
				alt={formatMessage(
					fg('jira-issue-terminology-refresh-m3')
						? messages.generatingIssueTermRefresh
						: messages.generating,
				)}
			/>
			<Box as="p" xcss={textStyle}>
				{message}
			</Box>
		</Flex>
	);
};

const textStyle = xcss({
	color: 'color.text.subtlest',
	margin: 'space.0',
	padding: 'space.0',
	display: 'flex',
	alignItems: 'center',
	gap: 'space.050',
});

const baseContainerStyle = xcss({
	alignItems: 'center',
	paddingBlockStart: 'space.150',
	paddingBlockEnd: 'space.150',
	gap: 'space.100',
});

const withPaddingStyle = xcss({
	paddingInline: 'space.150',
});

const noPaddingStyle = xcss({
	paddingInline: 'space.0',
});
